module.exports = __webpack_public_path__ + "static/media/slider_4_master_user_es.bf0ca739.svg";